import React from "react";
import { CommonHero } from "design-components/commonHero/CommonHero";
import type { BaseComponent } from "types/contentful";
import { contentfulBaseComponent } from "utils/contentfulBaseComponent";

const CommonHeroComponent = (props: BaseComponent) => {
  const args = contentfulBaseComponent(props);
  return (
    <React.Fragment>
      <CommonHero {...args} />
    </React.Fragment>
  );
};

export default CommonHeroComponent;
